import { create } from 'zustand';
import { parseSqlError, type ParsedSqlError } from '@/shared/lib/octo/sqlError';

/**
 * Yapılandırılmış hataların gösterildiği tek pencere.
 *
 * Veritabanından gelen hatalar `Konum / Satır / Mesaj` bloğu halinde geliyor
 * (SP100_GenerateError). Bu metin bildirim kutusuna sığmıyor, sığsa da iş mesajı
 * teknik gürültünün içinde kayboluyor — bu yüzden bildirim yerine pencere açılıyor.
 *
 * Kısa hatalar (bağlantı koptu, alan zorunlu) bildirimde kalmaya devam ediyor; her
 * hata için pencere açmak akışı gereksiz yere kesiyordu.
 */
interface ErrorDialogState {
  error: ParsedSqlError | null;
  show: (raw: string) => void;
  close: () => void;
}

export const useErrorDialogStore = create<ErrorDialogState>((set) => ({
  error: null,
  show: (raw) => set({ error: parseSqlError(raw) }),
  close: () => set({ error: null }),
}));
